var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvalanche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 60,
    viewBox: "0 0 207 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_332_17169)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 30.0974,
    r: 24,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.699 45.4953C39.3692 45.4953 46.3979 38.4667 46.3979 29.7964C46.3979 21.1261 39.3692 14.0974 30.699 14.0974C22.0287 14.0974 15 21.1261 15 29.7964C15 38.4667 22.0287 45.4953 30.699 45.4953ZM25.9554 36.9087H22.2726C21.3994 36.9087 20.9628 36.9087 20.7014 36.7396C20.4188 36.5569 20.2405 36.2502 20.2216 35.9145C20.2041 35.6037 20.4203 35.2249 20.8528 34.4672L20.853 34.467L28.9164 20.3408C29.3552 19.572 29.5746 19.1875 29.8539 19.0444C30.1555 18.8898 30.5132 18.8895 30.815 19.0437C31.0945 19.1864 31.3144 19.5706 31.7544 20.3388L33.6141 23.5857L33.6142 23.5858C33.9341 24.1444 34.0941 24.4237 34.1644 24.7184C34.241 25.0392 34.2411 25.3734 34.1649 25.6942C34.0948 25.989 33.935 26.2685 33.6155 26.8274L28.7937 35.2626C28.4696 35.8297 28.3075 36.1132 28.0854 36.3252C27.8437 36.5559 27.5506 36.7259 27.2302 36.8212C26.9359 36.9087 26.6091 36.9087 25.9554 36.9087ZM39.0947 36.9087H34.8248C33.9438 36.9087 33.5032 36.9087 33.2409 36.7381C32.9575 36.5538 32.7797 36.2449 32.763 35.9075C32.7474 35.5953 32.9692 35.2148 33.4126 34.4541L35.544 30.7974C35.9819 30.0463 36.2008 29.6707 36.478 29.53C36.7775 29.378 37.1317 29.3777 37.4316 29.5293C37.709 29.6695 37.9284 30.0448 38.3672 30.7952L38.3673 30.7954L40.5058 34.4521C40.9509 35.2133 41.1735 35.5939 41.1583 35.9064C41.1418 36.2441 40.9642 36.5533 40.6806 36.7379C40.4183 36.9087 39.9771 36.9087 39.0947 36.9087Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9322 24.3333H74.6172L79.3322 35.2781H77.1061L76.0858 32.7738H71.34L70.3506 35.2781H68.1709L72.9322 24.3333ZM75.4056 31.1042L73.7206 26.6521L72.0047 31.1042H75.4056Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4219 24.3333H83.6634L86.6469 32.6038L89.7232 24.3333H91.8259L87.4045 35.2781H85.7196L81.4219 24.3333Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7865 24.3333H100.472L105.186 35.2781H102.96L101.94 32.7738H97.1943L96.2048 35.2781H94.0254L98.7865 24.3333ZM101.26 31.1042L99.5751 26.6521L97.8591 31.1042H101.26Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.495 24.3333H111.443V33.5158H116.096V35.2781H109.495V24.3333Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.143 24.3333H125.828L130.543 35.2781H128.317L127.297 32.7738H122.551L121.562 35.2781H119.382L124.143 24.3333ZM126.616 31.1042L124.932 26.6521L123.216 31.1042H126.616Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.851 24.3333H137.433L142.735 32.4646H142.766V24.3333H144.714V35.2781H142.241L136.83 26.884H136.799V35.2781H134.851V24.3333Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.759 26.8996C157.357 26.4667 156.966 26.1782 156.584 26.0339C156.213 25.8896 155.837 25.8175 155.456 25.8175C154.889 25.8175 154.374 25.9206 153.91 26.1267C153.457 26.3225 153.065 26.6007 152.735 26.9615C152.405 27.3119 152.148 27.7241 151.962 28.1981C151.787 28.6722 151.699 29.1824 151.699 29.7286C151.699 30.316 151.787 30.8571 151.962 31.3518C152.148 31.8465 152.405 32.2742 152.735 32.6349C153.065 32.9956 153.457 33.279 153.91 33.4851C154.374 33.6912 154.889 33.7943 155.456 33.7943C155.899 33.7943 156.327 33.6912 156.739 33.4851C157.161 33.2686 157.553 32.9286 157.914 32.4648L159.522 33.6088C159.027 34.289 158.424 34.7837 157.712 35.0928C157.002 35.402 156.244 35.5566 155.44 35.5566C154.595 35.5566 153.817 35.4226 153.106 35.1547C152.405 34.8764 151.797 34.4899 151.282 33.9952C150.777 33.4902 150.38 32.8874 150.092 32.1866C149.803 31.4858 149.659 30.7077 149.659 29.8522C149.659 28.9763 149.803 28.1827 150.092 27.4716C150.38 26.7502 150.777 26.137 151.282 25.632C151.797 25.127 152.405 24.7405 153.106 24.4726C153.817 24.1943 154.595 24.0552 155.44 24.0552C156.182 24.0552 156.868 24.1892 157.497 24.4571C158.135 24.7148 158.728 25.1579 159.274 25.7866L157.759 26.8996Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.921 24.3333H165.868V28.6927H170.985V24.3333H172.933V35.2781H170.985V30.455H165.868V35.2781H163.921V24.3333Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.471 24.3333H185.721V26.0956H180.419V28.7854H185.443V30.5477H180.419V33.5158H186V35.2781H178.471V24.3333Z",
    fill: "#F9FBFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_332_17169",
    x: -81.5485,
    y: -81.451,
    width: 370.097,
    height: 222.097,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 40.7742
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_332_17169"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_332_17169",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.10cb749ab63f649f9e587ce1c24da718.svg";
export { ForwardRef as ReactComponent };